var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/Lightning/Filled",
    clipPath: "url(#clip0_5837_5909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.45417 11.6794L11.251 0.883712C11.7668 0.169624 12.8934 0.639753 12.7486 1.50862L11.6666 8.00063H15.8701C16.55 8.00063 16.9437 8.77076 16.5457 9.32187L8.74883 20.1175C8.2331 20.8316 7.10646 20.3615 7.25127 19.4926L8.33327 13.0006H4.12974C3.44993 13.0006 3.05615 12.2305 3.45417 11.6794Z",
    fill: "#23719F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5837_5909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderIcon);
export default __webpack_public_path__ + "static/media/ThunderIcon.34fb64cbd0596ef6e9a1a67e7955a01a.svg";
export { ForwardRef as ReactComponent };